import React, { useState } from 'react';
import {  Typography } from "@material-ui/core";
import {
    Loader,
    objestados,
    usuario_habilitado_sede,
    deshabilitar,moment
} from './index.js';

import { useMinistro } from '../../hooks/useMinistro.js';
import { Spinner } from '@material-tailwind/react';
import Main from '../../../../componentes/Main.js';
import {Dialogos} from '../../../../componentes/MUI/Dialogos'


import { Acta } from '../modulos/componentes/Acta';
import { FechaActa } from '../modulos/componentes/FechaActa';
import { Botones } from '../modulos/componentes/Botones';
import { PanelDatosGenerales } from '../modulos/componentes/PanelDatosGenerales';
import { PanelEntrevista } from '../modulos/componentes/PanelEntrevista';
import { PanelAdjuntos } from '../modulos/componentes/PanelAdjuntos';
import { PanelAdjuntosDinamico } from '../modulos/componentes/PanelAdjuntosDinamico.js';
import { ColumnasDinamicas } from '../modulos/componentes/ColumnasDinamicas.js';
import { FilasDinamicas } from '../modulos/componentes/FilasDinamicas.js';
import { ValidacionesCheckboxes } from '../modulos/componentes/ValidacionesCheckboxes';
import { Description } from '@mui/icons-material';

export const TR_MinistroNew = ({ id, cabecera, setData, usuario, snackbar, puedeEditarse, cambiarStatus,finalizar }) => {

    const {
        error, loading, loading2, procesando, datosDelTramite, status_actual_tramite,
        acta_regional, setActa_regional, fechaAR, handleChangeFechaAR, setActa_cdn, fechaACDN,
        handleChangeFechaACDN, inicioActualizacionTramite, actualizarTramite, touched, refrescar,
        acta_cdn, refrescando, traerUrl, accederEntrevista, IniciarCerrarEntrevista,
        analitico, handleChangeAnaliticoCheck,
        cambiarAnalitico,setCambiarAnalitico, 
        cambiarCertMat,setCambiarCertMat,
        cambiarAntecedentesPen,setCambiarAntecedentesPen,
        cambiarFoto4x4,setCambiarFoto4x4,
        cambiarDniReverso,setCambiarDniReverso,
        cambiarDniFrente,setCambiarDniFrente,
        cambiarExtra1,setCambiarExtra1,
        nuevoExtra1, setNuevoExtra1,
        nuevoAnalitico,setNuevoAnalitico,
        nuevoDniFrente,setNuevoDniFrente,
        nuevoDniReverso,setNuevoDniReverso,
        nuevoFoto4x4,setNuevoFoto4x4,
        nuevoAntecedentesPen,setNuevoAntecedentesPen,
        nuevoCertMat,setNuevoCertMat,
        linkEntrevista, copiarLink
    } = useMinistro(cabecera, id, setData, usuario, snackbar);

    const [activeTab, setActiveTab] = useState('informacion_general');
    const [aux, setAux] = useState(false);

    const sinCambiosPendientes = () => {
        return !(cambiarAnalitico && !nuevoAnalitico) &&
         !(cambiarExtra1 && !nuevoExtra1) && 
         !(cambiarDniFrente && !nuevoDniFrente) && 
         !(cambiarDniReverso && !nuevoDniReverso) && 
         !(cambiarFoto4x4 && !nuevoFoto4x4) && 
         !(cambiarAntecedentesPen && !nuevoAntecedentesPen) && 
         !(cambiarCertMat && !nuevoCertMat);
    };

    if (error) return <div className="p-4 bg-red-50 text-red-700 rounded-lg"><p>{JSON.stringify(error)}</p></div>;
    
    if (loading || loading2 || procesando) {
        return (
            <Main center alinear>
                <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)] gap-3'>
                    <Spinner className="h-12 w-12 text-blue-500" />
                    <span className="font-semibold text-gray-600 text-sm">Cargando...</span>
                </div>
            </Main>
        );
    }
    
    if (!datosDelTramite) return <div className="p-8 text-center"><Spinner className="h-12 w-12 mx-auto text-blue-500" /><p className="text-gray-500 mt-2">Cargando solicitud...</p></div>;

    return (
        <div id="solicitud-proceso" className="w-full mx-auto space-y-4 antialiased text-gray-800">
              <a
                href="#documentos-acept"
            >
                Aceptación de documentos
            </a>
            <button onClick={()=>setAux(true)}>test</button>
            <Loader open={refrescando} />
            <div className="flex flex-col col-span-1 lg:col-span-7 bg-gray-50 border border-gray-200 rounded-md p-2  shadow-sm overflow-y-auto max-h-[500px]">
                <div className='flex'>
                <ValidacionesCheckboxes 
                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                    campo_check={analitico}
                    label_checked="Analítico confirmado"
                    label_unchecked_no_autorizado="Confirmación de analítico pendiente"
                    label_unchecked_autorizado="El analítico es válido"
                    handleChange={handleChangeAnaliticoCheck}
                />
                                         <div className="flex items-center gap-1.5 py-2">
            {(deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region') && <span className="text-sm font-semibold text-trf-600 bg-green-50 px-2.5 py-1 rounded-md border border-green-200">
                                                Cambios permitidos solo para Secretarios Regionales en estado "En proceso regional".
            </span>}
            </div>
                </div>
                <div className="flex">
                    <div className="flex flex-col gap-1">
                        <div className="flex flex-row flex-wrap gap-4 border border-gray-300 rounded-md bg-white p-3">
                                <Acta 
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                    setActa={setActa_regional}
                                    acta={acta_regional}
                                    titulo="Número Acta Regional"
                                />
                                <FechaActa
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        handleChangeFecha={handleChangeFechaAR}
                                        fecha={fechaAR}
                                        titulo="Fecha Acta Regional"
                                />                              
                                <Acta 
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procSede.nombre], 'no_encontrado') || !usuario_habilitado_sede(usuario)}
                                    setActa={setActa_cdn}
                                    acta={acta_cdn}
                                    titulo="Número Acta CDN"
                                />       
                                <FechaActa
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procSede.nombre], 'no_encontrado') || !usuario_habilitado_sede(usuario)}
                                        handleChangeFecha={handleChangeFechaACDN}
                                        fecha={fechaACDN}
                                        titulo="Fecha Acta CDN"
                                />     
                                            
                    
                        </div>
                    </div>
                    <div className='flex flex-col'>

                                     

                    <div className='flex'>
                     <PanelAdjuntosDinamico 
                                                titulo="Analítico"
                                                url={datosDelTramite?.adjuntos?.analitico}
                                                editando={cambiarAnalitico}
                                                nuevoArchivo={nuevoAnalitico}
                                                setEditando={setCambiarAnalitico}
                                                setNuevoArchivo={setNuevoAnalitico}
                                                removeClasses={true}                                      
                                                traerUrl={traerUrl}
                                                icono={true}
                                                deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                            />

                                            <PanelAdjuntosDinamico 
                                                titulo="DNI Frente"
                                                url={datosDelTramite?.adjuntos?.dni_frente}
                                                editando={cambiarDniFrente}
                                                nuevoArchivo={nuevoDniFrente}
                                                setEditando={setCambiarDniFrente}
                                                icono={true}
                                                removeClasses={true}                                      
                                                setNuevoArchivo={setNuevoDniFrente}
                                                traerUrl={traerUrl}
                                                deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                            />
                                             <PanelAdjuntosDinamico 
                                                titulo="DNI Reverso"
                                                url={datosDelTramite?.adjuntos?.dni_reverso}
                                                editando={cambiarDniReverso}
                                                icono={true}
                                                removeClasses={true}                                      
                                                nuevoArchivo={nuevoDniReverso}
                                                setEditando={setCambiarDniReverso}
                                                setNuevoArchivo={setNuevoDniReverso}
                                                traerUrl={traerUrl}
                                                deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                            />
                                            <PanelAdjuntosDinamico 
                                            titulo="Foto"
                                            url={datosDelTramite?.adjuntos?.foto_4x4}
                                            editando={cambiarFoto4x4}
                                            nuevoArchivo={nuevoFoto4x4}
                                            icono={true}    
                                            removeClasses={true}                                      
                                            setEditando={setCambiarFoto4x4}
                                            setNuevoArchivo={setNuevoFoto4x4}
                                            traerUrl={traerUrl}
                                            deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        />
                                    </div>
                                    <div className='flex'>
                                            <PanelAdjuntosDinamico 
                                            titulo="Cert. de antecedentes penales"
                                            url={datosDelTramite?.adjuntos?.antecedentes_pen}
                                            editando={cambiarAntecedentesPen}
                                            icono={true}       
                                            removeClasses={true}                                                                               
                                            nuevoArchivo={nuevoAntecedentesPen}
                                            setEditando={setCambiarAntecedentesPen}
                                            setNuevoArchivo={setNuevoAntecedentesPen}
                                            traerUrl={traerUrl}
                                            deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        />
                                         <PanelAdjuntosDinamico 
                                            titulo="Cert. matrimonio"
                                            url={datosDelTramite?.adjuntos?.cert_mat}
                                            editando={cambiarCertMat}
                                            nuevoArchivo={nuevoCertMat}
                                            icono={true}     
                                            removeClasses={true}                                      
                                            setEditando={setCambiarCertMat}
                                            setNuevoArchivo={setNuevoCertMat}
                                            traerUrl={traerUrl}
                                            deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        />
                                      
                                   <PanelAdjuntosDinamico 
                                            titulo="Extra 1"
                                            url={datosDelTramite?.adjuntos?.extra_1URL}
                                            editando={cambiarExtra1}
                                            nuevoArchivo={nuevoExtra1}
                                            icono={true}       
                                            removeClasses={true}   
                                            setEditando={setCambiarExtra1}
                                            setNuevoArchivo={setNuevoExtra1}
                                            traerUrl={traerUrl}
                                            deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        />

                                        
                    </div>
                                    </div>

                    {/* <div className='flex flex-col'>

                        <ColumnasDinamicas
                            columnas={[
                                {
                                valor: ( <PanelAdjuntosDinamico 
                                                titulo="Analítico"
                                                url={datosDelTramite?.adjuntos?.analitico}
                                                editando={cambiarAnalitico}
                                                nuevoArchivo={nuevoAnalitico}
                                                setEditando={setCambiarAnalitico}
                                                setNuevoArchivo={setNuevoAnalitico}
                                                removeClasses={true}                                      
                                                traerUrl={traerUrl}
                                                icono={true}
                                                deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                            />),
                                },
                                {
                                valor: (<PanelAdjuntosDinamico 
                                                titulo="DNI Frente"
                                                url={datosDelTramite?.adjuntos?.dni_frente}
                                                editando={cambiarDniFrente}
                                                nuevoArchivo={nuevoDniFrente}
                                                setEditando={setCambiarDniFrente}
                                                icono={true}
                                                removeClasses={true}                                      
                                                setNuevoArchivo={setNuevoDniFrente}
                                                traerUrl={traerUrl}
                                                deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                            />),
                                },
                                {
                                valor: (  <PanelAdjuntosDinamico 
                                                titulo="DNI Reverso"
                                                url={datosDelTramite?.adjuntos?.dni_reverso}
                                                editando={cambiarDniReverso}
                                                icono={true}
                                                removeClasses={true}                                      
                                                nuevoArchivo={nuevoDniReverso}
                                                setEditando={setCambiarDniReverso}
                                                setNuevoArchivo={setNuevoDniReverso}
                                                traerUrl={traerUrl}
                                                deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                            />),
                                },
                                
                            ]}
                            />
                                                    <ColumnasDinamicas
                            columnas={[
                                {
                                valor: ( <PanelAdjuntosDinamico 
                                            titulo="Foto"
                                            url={datosDelTramite?.adjuntos?.foto_4x4}
                                            editando={cambiarFoto4x4}
                                            nuevoArchivo={nuevoFoto4x4}
                                            icono={true}    
                                            removeClasses={true}                                      
                                            setEditando={setCambiarFoto4x4}
                                            setNuevoArchivo={setNuevoFoto4x4}
                                            traerUrl={traerUrl}
                                            deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        />),
                                },
                                {
                                valor: (  <PanelAdjuntosDinamico 
                                            titulo="Cert. matrimonio"
                                            url={datosDelTramite?.adjuntos?.cert_mat}
                                            editando={cambiarCertMat}
                                            nuevoArchivo={nuevoCertMat}
                                            icono={true}     
                                            removeClasses={true}                                      
                                            setEditando={setCambiarCertMat}
                                            setNuevoArchivo={setNuevoCertMat}
                                            traerUrl={traerUrl}
                                            deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        />),
                                },
                                {
                                valor: (   <PanelAdjuntosDinamico 
                                            titulo="Cert. de antecedentes penales"
                                            url={datosDelTramite?.adjuntos?.antecedentes_pen}
                                            editando={cambiarAntecedentesPen}
                                            icono={true}       
                                            removeClasses={true}                                                                               
                                            nuevoArchivo={nuevoAntecedentesPen}
                                            setEditando={setCambiarAntecedentesPen}
                                            setNuevoArchivo={setNuevoAntecedentesPen}
                                            traerUrl={traerUrl}
                                            deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        />),
                                },
                                {
                                    valor:( <PanelAdjuntosDinamico 
                                            titulo="Extra 1"
                                            url={datosDelTramite?.adjuntos?.extra_1URL}
                                            editando={cambiarExtra1}
                                            nuevoArchivo={nuevoExtra1}
                                            icono={true}       
                                            removeClasses={true}   
                                            setEditando={setCambiarExtra1}
                                            setNuevoArchivo={setNuevoExtra1}
                                            traerUrl={traerUrl}
                                            deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        />)
                                }
                                
                            ]}
                            />

                    </div> */}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full text-left items-start antialiased">
{/*                     
                    <PanelDatosGenerales
                        datosDelTramite={datosDelTramite}
                        atributos={[
                            {
                                valor:'valor',descripcion:'Un campo'
                            },
                             {
                                descripcion: 'Ejemplo jsx',
                                valor: (
                                    <div className="flex items-center justify-between gap-2 w-full mt-0.5">
                                        <span className="truncate">ejemplo jsx</span>
                                        
                                    </div>
                                )
                            },
                             { valor: () => (
                                    <FilasDinamicas 
                                        filas={[
                                            { 
                                                etiqueta: 'Filas', 
                                                valor: 'SI' 
                                            },
                                            { 
                                                etiqueta: 'Dinámicas', 
                                                valor: `xx`,
                                                mostrar: true 
                                            },
 { 
                                                etiqueta: 'Dinámicas', 
                                                valor: `xx`,
                                                mostrar: true 
                                            }                                            
                                        ]} 
                                    />
                                )
                            },
                             {
                                descripcion: 'Ejemplo de col dinamicas',
                                valor: () => (
                                    <ColumnasDinamicas 
                                        columnas={[
                                            { etiqueta: 'Fijo', valor: 'test' },
                                            { etiqueta: 'Celular', valor: 'test' },
                                            { etiqueta: 'otro', valor: 'test' },
                                            { etiqueta: 'otro', valor: 'test' },
                                            { etiqueta: 'otro', valor: 'test' },
                                            { etiqueta: 'otro', valor: 'test' }

                                        ]} 
                                    />
                                )
                            },
                        ]}
                    />
                     */}



<PanelDatosGenerales
  datosDelTramite={datosDelTramite}
  atributos={[
    // --- IGLESIA VINCULADA ---
     {
      descripcion: 'Nombre y Apellido',
      valor: `${datosDelTramite?.personales?.apellido}, ${datosDelTramite?.personales?.nombre}`,
    },
    {
      valor: () => (
        <ColumnasDinamicas
          columnas={[
            {
              etiqueta: 'Sexo',
              valor: datosDelTramite?.personales?.sexo === 'M' ? 'Masculino' : 'Femenino',
            },
            {
              etiqueta: 'DNI',
              valor: datosDelTramite?.personales?.nro_documento,
            },
            {
              etiqueta: 'Nacionalidad',
              valor: datosDelTramite?.personales?.nacionalidad?.nombre,
            },
          ]}
        />
      ),
    },
    {
      valor: () => (
        <ColumnasDinamicas
          columnas={[
            {
              etiqueta: 'Fecha Nac.',
              valor: moment(
        Number(datosDelTramite?.personales?.fecha_nacimiento)
      ).format('DD-MM-YYYY'),
            },
            {
              etiqueta: 'Estado civil',
              valor: datosDelTramite?.personales?.estado_civil?.nombre,
            },
            {
              etiqueta: 'Cónyuge',
              valor: datosDelTramite?.personales?.conyuge || 'N/A',
            },
          ]}
        />
      ),
    },
     {
      valor: () => (
        <ColumnasDinamicas
          columnas={[
            {
              etiqueta: 'Año conversión',
              valor: datosDelTramite?.conversion?.year_conversion,
            },
            {
              etiqueta: 'Año bautismo agua',
              valor: datosDelTramite?.conversion?.year_bautismo,
            },
            {
              etiqueta: 'Bautismo Espíritu Santo',
              valor: datosDelTramite?.conversion?.bautismo_es ? 'SI' : 'NO',
            },
          ]}
        />
      ),
    },
    ]}
/>
<PanelDatosGenerales
  datosDelTramite={datosDelTramite}
  atributos={[
    // --- IGLESIA VINCULADA ---
     {
      descripcion: 'Iglesia vinculada',
      valor: `${datosDelTramite?.iglesia?.iglesia?.nombre} (${datosDelTramite?.iglesia?.iglesia?.id})`,
    },
    {
      valor: () => (
        <ColumnasDinamicas
          columnas={[
            {
              etiqueta: 'Partido',
              valor: datosDelTramite?.iglesia?.partido?.nombre,
            },
            {
              etiqueta: 'Provincia',
              valor: datosDelTramite?.iglesia?.provincia?.nombre,
            },
          ]}
        />
      ),
    },
      {
      descripcion: 'Declara haber trabajado con',
      valor: (
        <div className="flex flex-col gap-1">
          {datosDelTramite?.pastores?.map((item, index) => (
            <span key={index} className="text-sm">
              {item}
            </span>
          ))}
        </div>
      ),
    },
     {
      descripcion: 'Sostenimiento financiero',
      valor: datosDelTramite?.finanzas?.sostenimiento,
    },
    {
      descripcion: 'Diezmo',
      valor: datosDelTramite?.finanzas?.diezmo ? 'SI' : 'NO',
    },
    ]}
/>
<PanelDatosGenerales
  datosDelTramite={datosDelTramite}
  atributos={[
    // --- DOMICILIO ---
   {
      valor: () => (
        <FilasDinamicas
          filas={[
            {
              etiqueta: 'Dirección',
              valor: datosDelTramite?.domicilio?.direccion,
              mostrar: true,
            },
            {
              etiqueta: 'Localidad',
              valor: datosDelTramite?.domicilio?.localidad,
              mostrar: true,
            },
            {
              etiqueta: 'Partido',
              valor: datosDelTramite?.domicilio?.partido?.nombre,
              mostrar: true,
            },
          ]}
        />
      ),
    },
    {
      valor: () => (
        <ColumnasDinamicas
          columnas={[
            {
              etiqueta: 'Barrio',
              valor: simplificar(datosDelTramite?.domicilio?.barrio,'No registrado','--'),
            },
            {
              etiqueta: 'C.P.',
              valor: datosDelTramite?.domicilio?.cod_postal,
            },
            {
              etiqueta: 'Provincia',
              valor: datosDelTramite?.domicilio?.provincia?.nombre,
            },
          ]}
        />
      ),
    },

    // --- INFORMACIÓN DE CONTACTO ---
    {
      valor: () => (
        <ColumnasDinamicas
          columnas={[
            {
              etiqueta: 'Teléfono',
              valor: datosDelTramite?.contacto?.telefono,
            },
            {
              etiqueta: 'Celular',
              valor: datosDelTramite?.contacto?.celular,
            },
          ]}
        />
      ),
    },
     {
                          valor: datosDelTramite?.contacto?.email,

    },

    // --- INFORMACIÓN FINANCIERA ---
   

       // --- PASTORES ---
  

    // --- CONFORMIDAD DE DOCUMENTOS UAD ---
   
  ]}
/>
                    {/* <PanelAdjuntos
                        usuario={usuario}
                        status_actual_tramite={status_actual_tramite}
                        datosDelTramite={datosDelTramite}
                        cambiarAnalitico={cambiarAnalitico}
                        nuevoAnalitico={nuevoAnalitico}
                        cambiarExtra1={cambiarExtra1}
                        nuevoExtra1={nuevoExtra1}
                        traerUrl={traerUrl}
                        setCambiarAnalitico={setCambiarAnalitico}
                        setCambiarExtra1={setCambiarExtra1}
                        setNuevoAnalitico={setNuevoAnalitico}
                        setNuevoExtra1={setNuevoExtra1}
                    />     */}


                </div>
                    {/* <div className={`bg-red-400 absolute top-0 flex p-4 ${!aux ? 'hidden':'block'}`}> */}


    <PanelEntrevista
                        status_actual_tramite={status_actual_tramite}
                        datosDelTramite={datosDelTramite}
                        linkEntrevista={linkEntrevista}
                        copiarLink={copiarLink}
                        accederEntrevista={accederEntrevista}
                        IniciarCerrarEntrevista={IniciarCerrarEntrevista}
                        refrescar={refrescar}
                        usuario={usuario}
                    />
            </div>
            <Botones
                sinCambiosPendientes={sinCambiosPendientes}
                touched={touched}
                inicioActualizacionTramite={inicioActualizacionTramite}
                actualizarTramite={actualizarTramite}
                cambiarStatus={cambiarStatus}
                finalizar={finalizar}
                puedeEditarse={puedeEditarse}
            />
        
         <Dialogos open={aux} 
                    procesarCancelar = {()=>setAux(false)}
                >
                      <PanelAdjuntosDinamico 
                                            titulo="Analítico"
                                            url={datosDelTramite?.adjuntos?.analitico}
                                            editando={cambiarAnalitico}
                                            nuevoArchivo={nuevoAnalitico}
                                            setEditando={setCambiarAnalitico}
                                            setNuevoArchivo={setNuevoAnalitico}
                                            traerUrl={traerUrl}
                                            deshabilitado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        />
                    
            </Dialogos>  
        </div>

        
    );

           
};

const simplificar = (valor,excluir,stringNoValor) => {
    if(!valor){
        return stringNoValor ? stringNoValor : '--';
    }

    if(valor.includes(excluir)){
        return stringNoValor ? stringNoValor : '--';
    }

    return valor;

}